import { Component, Inject, OnInit } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { User } from '../../../core/models/classes/user';
import { UserProfileModel } from '../../../core/models/classes/user-profile';
import { UserService } from '../../../core/services/user.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Role } from 'src/app/core/models/enums/user-role';

@Component({
  selector: 'app-createuser',
  templateUrl: './createuser.component.html',
  styleUrls: ['./createuser.component.scss'],
})

export class CreateUserDialogComponent implements OnInit {
  name = new FormControl('', [Validators.required, Validators.nullValidator]);

  password = new FormControl('', [
    Validators.required,
    Validators.nullValidator,
  ]);

  selectedrole: string;

  firstName = new FormControl('', [
    Validators.required,
    Validators.nullValidator,
  ]);
  lastName = new FormControl('', [
    Validators.required,
    Validators.nullValidator,
  ]);

  email = new FormControl('', [
    Validators.required,
    Validators.nullValidator,
    Validators.email,
  ]);
  company = new FormControl('', [
    Validators.required,
    Validators.nullValidator,
  ]);

  roles: string[] = [];

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private userService: UserService,
    private _snackBar: MatSnackBar,
    public dialogRef: MatDialogRef<CreateUserDialogComponent>,
    public router: Router
  ) {}

  ngOnInit(): void {
    const userId = localStorage.getItem('loginId');
    this.userService.getUserRole(+userId).subscribe({
      next: (data) => {
        this.roles = ['Admin', 'User'];       
      },
    });
  }

  createNewUser(): void {
    var isValid = this.validateEntries();
    if(isValid === 1){
      var user = new User();
      user.name = this.name.value;
      user.password = this.password.value;
      user.roleId =
        Role[this.selectedrole] === undefined ? 0 : Role[this.selectedrole];
      user.schemaName = localStorage.getItem('schema');
      var profile = new UserProfileModel();
      profile.firstName = this.firstName.value;
      profile.lastName = this.lastName.value;
      profile.email = this.email.value;
      profile.company = this.company.value;
      this.addUser(user, profile);      
    }
  }

  addUser(user: User, profile: UserProfileModel){
    this.userService.addNewUser(user).subscribe({
      next: (data) => {
        if (data !== 0 && data !== -1) {
          //add profile
          profile.userId = data;
          this.userService.addNewProfile(profile).subscribe({
            next: (data) => {
              if (data.status === 200) {
                this._snackBar.open($localize `User added successfully`, '', {
                  duration: 3000
                });
                this.dialogRef.close();                
              }
            },
            error: (err) => {
              throw Error(err.Status);
            },
          });
        } else if (data === -1) {
          throw Error($localize `Username already exists`);
        }
      },
      error: (err) => {
        throw Error(err.Status);
      },
    });
  }

  validateEntries(): number{
    if(this.name.value === "" || this.password.value === "" 
      || Role[this.selectedrole] === undefined || this.firstName.value === "" 
      || this.lastName.value === "" || this.email.value === "" || this.company.value === ""){
        this._snackBar.open($localize `Fields cannot be empty`, '', {
          duration: 3000
        });
      return 0;
    }
    else if(this.name.value.includes(' ')){
      this._snackBar.open($localize `Spaces not allowed in username`, '', {
        duration: 3000
      });
      return 0;
    }
    else{
      return 1;
    }
  }

  selectedRole(value: any) {
    this.selectedrole = value;
  }
}
